import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaCalculator, FaBalanceScale, FaChartPie, FaRegMoneyBillAlt, FaClipboardCheck, FaClock } from "react-icons/fa";
import { Link } from "react-router-dom";

const BenefitsSection = () => {
    useEffect(() => {
        AOS.init({ duration: 1000, mirror: true, once: false });
    }, []);

    return (
        <section className="benefits-section py-5">
            <div className="container">
                <div className="row align-items-center">

                   
                    <div className="col-lg-6 text-start" data-aos="fade-right">
                        <span className="section-indicator">• Nos Atouts</span>
                        <h2 className="fw-bold">
                            Bénéfices stratégiques pour <br />
                            <span className="gradient-text">votre croissance comptable</span>
                        </h2>
                        <p className="text-muted text-justify">
                            Optimisez la gestion financière de votre entreprise grâce à notre expertise comptable.
                            Nous vous aidons à structurer vos finances, à maximiser votre rentabilité
                            et à sécuriser votre conformité fiscale.
                        </p>

                        <Link to="/contact" className="cta-button" data-aos="zoom-in">
                            Obtenez une consultation gratuite ↗
                        </Link>
                    </div>

                    
                    <div className="col-lg-6">
                        <div className="row">
                            <div className="col-md-6 service-box" data-aos="fade-up">
                                <FaCalculator className="service-icon" />
                                <h5>Gestion Comptable</h5>
                                <p>Optimisation des comptes, reporting et conformité financière.</p>
                            </div>
                            <div className="col-md-6 service-box" data-aos="fade-up">
                                <FaBalanceScale className="service-icon" />
                                <h5>Audit & Contrôle</h5>
                                <p>Analyse approfondie pour garantir l'exactitude et la conformité.</p>
                            </div>
                            <div className="col-md-6 service-box" data-aos="fade-up">
                                <FaChartPie className="service-icon" />
                                <h5>Optimisation Fiscale</h5>
                                <p>Stratégies pour réduire la charge fiscale et maximiser les bénéfices.</p>
                            </div>
                            <div className="col-md-6 service-box" data-aos="fade-up">
                                <FaRegMoneyBillAlt className="service-icon" />
                                <h5>Gestion de Trésorerie</h5>
                                <p>Planification et prévision pour assurer la stabilité financière.</p>
                            </div>
                            <div className="col-md-6 service-box" data-aos="fade-up">
                                <FaClipboardCheck className="service-icon" />
                                <h5>Conseil Stratégique</h5>
                                <p>Accompagnement dans la prise de décisions financières cruciales.</p>
                            </div>
                            <div className="col-md-6 service-box" data-aos="fade-up">
                                <FaClock className="service-icon" />
                                <h5>Optimisation des Processus</h5>
                                <p>Automatisation des tâches comptables pour plus d'efficacité.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <style>{`
                .benefits-section {
                    background: #fff;
                    padding: 80px 0;
                }

                .section-indicator {
                    color: #e63946;
                    font-weight: bold;
                    text-transform: uppercase;
                    display: block;
                    margin-bottom: 10px;
                }

                .gradient-text {
                    background: linear-gradient(90deg, #2a77ff, #e63946);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }

                .cta-button {
                    background: linear-gradient(45deg, #2a77ff, #e63946);
                    color: white;
                    padding: 12px 24px;
                    border-radius: 50px;
                    font-weight: bold;
                    text-decoration: none;
                    display: inline-block;
                    transition: transform 0.3s ease-in-out;
                }

                .cta-button:hover {
                    transform: scale(1.1);
                    opacity: 0.8;
                }

                .service-box {
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 10px;
                    margin-bottom: 30px;
                }

                .service-icon {
                    font-size: 30px;
                    color: #e63946;
                }

                .service-box h5 {
                    font-weight: bold;
                }

                .text-justify {
                    text-align: justify;
                }
            `}</style>
        </section>
    );
};

export default BenefitsSection;
